<div class="modal-overlay">
  <div class="modal-box">
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="modal-title">Review Your Booking</h2>
      <img src="assets/images/close_button.svg" (click)="close()" />
    </div>

    <div class="mentor-card awaiting">
      <div class="mentor-avatar awaiting-bg">
        <i class="bi bi-clock"></i>
      </div>
      <div class="me-3">
        <p class="timer-name">Slot Reserved</p>
        <p class="timer">
          Your selected time slot is held for
          <span class="times">{{ formatTime(remainingSeconds) }}</span> Complete
          payment to confirm.
        </p>
      </div>
      <div class="d-flex flex-column text-end">
        <p class="m-0 run-time">{{ formatTime(remainingSeconds) }}</p>
        <p class="m-0 left-time">REMAINING</p>
      </div>
    </div>
    <div class="mentor-card">
      <div class="mentor-avatar">
        {{ payload.first_name[0] }}{{ payload.last_name[0] }}
      </div>
      <div>
        <p class="mentor-name">
          {{ payload.first_name }} {{ payload.last_name }}
        </p>
        <p class="mentor-role">
          {{ payload.designation }} at {{ payload.company }}
        </p>
      </div>
    </div>
    <div class="modal-body">
      <div class="session-card">
        <h3 class="session-title">Session Details</h3>

        <div class="detail-row">
          <span class="label">Session Type</span>
          <span class="value">{{ payload.appointment_type_name }}</span>
        </div>

        <div class="divider"></div>

        <div class="detail-row">
          <span class="label">Date</span>
          <span class="value">{{
            payload.appointment_date | date: "dd MMM yyyy"
          }}</span>
        </div>

        <div class="divider"></div>

        <div class="detail-row">
          <span class="label">Time</span>
          <span class="value"> {{ payload.display }}</span>
        </div>

        <div class="divider"></div>

        <div class="detail-row">
          <span class="label">Duration</span>
          <span class="value"
            >{{ payload.duration_minutes }} mins
            <span
              class="free"
              *ngIf="
                payload.duration_minutes ===
                MentorSessionFreePayment.payment_duration
              "
              >(Free)</span
            ></span
          >
        </div>

        <div class="divider"></div>

        <div class="m-0">
          <span class="topic-label">Topics to Discuss</span>
          <div class="new-value">
            <p>{{ payload.topics_to_discuss }}</p>
          </div>
        </div>
      </div>
      <div class="mentor-card m-0 justify-content-between">
        <p class="mentor-name">Session Cost</p>
        <p class="mentor-name">{{ payload.price_display }}</p>
      </div>
    </div>
    <div class="modal-actions d-flex justify-content-between">
      <button class="cancel-btn" (click)="back()">← Back</button>
      <button
        *hasPermission="PermissionForStudents.PAYMENTS_CREATE"
        class="review-btn"
        (click)="postRazorPayment()"
        [disabled]="isLoading"
      >
        <ng-container *ngIf="isLoading; else noLoading">
          <span class="spinner-border spinner-border-sm"></span> Processing...
        </ng-container>
        <ng-template #noLoading> Proceed To Payment </ng-template>
      </button>
    </div>
  </div>
</div>
